const makeRedirectTo = (path, replace) => {
  if (replace) {
    window.location.replace(path);
  } else {
    window.location.assign(path);
  }
};

export default makeRedirectTo;
